
import Dashboard from "./dashboard";
import {routerConfig} from "./RouterConfig";
import {cashReqController, CashReqController} from "./templates/emailConfig/emailConfig.ctrl";
import RiskReportController from "./RiskReportController";
import RiskController from "./risk.ctrl";

const ModuleName = "tf.risk";

export default angular.module(ModuleName, [Dashboard])
                      .controller("riskReportCtrl", RiskReportController)
                      .controller("riskCtrl", RiskController)
                      .controller(CashReqController, cashReqController)
                      .config(routerConfig)
                      .name;
